export default {
  state: {
    id: undefined,
    name: undefined,
    slug: undefined,
    auto_subscribe: false,
    default_newsletter_type: undefined,
    default_free_newsletter_type: undefined,
    digest_providers: [],
    digestible: false,
    description: undefined,
    digest_dates: [],
    digest_interval: undefined,
    digest_interval_num: undefined,
    digest_interval_type: '',
    digest_last_sent_at: undefined,
    digest_last_sent_at_humanized: undefined,
    digest_should_start_at: undefined,
    digest_should_start_at_humanized: undefined,
    digest_weekday: undefined,
    editor_id: undefined,
    editor: {},
    default_reply_email: undefined,
    digest: false,
    digestiable: false,
    inactive: undefined,
    visible: undefined,
    mailing_list_id: undefined,
    newsletter_type_id: undefined,
    puzzle_link_id: undefined,
    is_public: undefined,
    requires_subscription: undefined,
    created_at: undefined,
    updated_at: undefined,
    readable_digest_interval: undefined,
    recipient_count: undefined,
    subscribers: [],
    subscriptions: [],
    header_html: undefined,
    footer_html: undefined,
    providers: [],
    parent_newsletter_type: {},
    relationships: {}
  }
}



// WEBPACK FOOTER //
// ./src/stores/NewsletterTypeStore.js